export const CUSTOMERS_DOMAIN = 'customers'
export const CUSTOMERS_ACTION = {
  LOAD_CURRENT: 'CUSTOMERS_LOAD_CURRENT',
  UPDATE_SOURCE: 'CUSTOMERS_UPDATE_SOURCE',
  DELETE_SOURCE: 'CUSTOMERS_DELETE_SOURCE'
}

export const CUSTOMERS_ENDPOINT = {
  GET_CUSTOMER_BY_ID: '/users/:id/customer',
  UPDATE_SOURCE_CUSTOMER: '/users/customer/source',
  DELETE_SOURCE: '/users/customer/source/:source'
}

export const CUSTOMERS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

export const CUSTOMERS_PATH = {
  ALL: `${CUSTOMERS_DOMAIN}.${CUSTOMERS_KEY.ALL}`,
  CURRENT: `${CUSTOMERS_DOMAIN}.${CUSTOMERS_KEY.CURRENT}`,
  DATA: `${CUSTOMERS_DOMAIN}.${CUSTOMERS_KEY.DATA}`
}

export const CUSTOMERS_STATE = {
  [CUSTOMERS_KEY.ALL]: {
    data: [],
    status: null
  },
  [CUSTOMERS_KEY.CURRENT]: null,
  [CUSTOMERS_KEY.DATA]: {}
}

export const CUSTOMER_CLASS_NAME = 'Customer'
